import React from 'react'

import { useFollowingFeedCacheStore } from 'store/followingFeedCacheStore'

export function HydrationGate({ children }: { children: React.ReactNode }) {
  const hydrated = useFollowingFeedCacheStore((s) => s.hasHydrated)

  if (!hydrated) return null // or a splash/loading screen
  return <>{children}</>
}